import React from "react";
import { motion } from "framer-motion";
import data from "../../data/index.json";
import { useTranslation } from "react-i18next";
import { Section, SectionHeader, reveal } from "../../components";
import aboutImage from "../../assets/ifb-audience.png";

const pillars = [
  { label: "Mission", title: "Solve for the real economy", key: "mission" },
  { label: "Vision", title: "An Africa that builds its own tools", key: "vision" },
];

const About = () => {
  const { t } = useTranslation();
  const { companyInfo } = data;

  return (
    <Section id="about" tone="warm">
      <SectionHeader
        index="01"
        label={t("Our Legacy")}
        title={
          <>
            {t("Engineering")} <em>{t("the future")}</em>{t(", from Bujumbura outward.")}
          </>
        }
        lede={t(
          "Hyphen Tech is a premier technology partner specializing in high-performance digital ecosystems and strategic AI integration. We bridge the gap between complex engineering and human-centric design."
        )}
      />

      {/* Wide documentary plate — the claim above, in the room where it happened. */}
      <motion.figure {...reveal()} className="mt-14 md:mt-20 group">
        <div className="overflow-hidden bg-paper-tint aspect-[21/9] md:aspect-[3/1]">
          <img
            src={aboutImage}
            alt={t(
              "Hyphen Tech CEO presenting AgriHyphen AI to a full auditorium at the Institut Français du Burundi"
            )}
            loading="lazy"
            width="1720"
            height="600"
            className="img-editorial"
          />
        </div>
        <figcaption className="flex flex-wrap gap-x-6 gap-y-1 justify-between">
          <span>
            {t(
              "Presenting AgriHyphen AI — Institut Français du Burundi"
            )}
          </span>
          <span className="tabular">03.03.2025</span>
        </figcaption>
      </motion.figure>

      {/* Mission / Vision as an editorial spread, not two more rounded cards. */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-16 mt-16 md:mt-24">
        {pillars.map((pillar, i) => (
          <motion.div
            key={pillar.key}
            {...reveal(i)}
            className="rule-gold pt-6"
          >
            <span className="label">{t(pillar.label)}</span>
            <h3 className="display-2 mt-4">{t(pillar.title)}</h3>
            <p className="prose-body mt-4">{t(companyInfo[pillar.key])}</p>
          </motion.div>
        ))}
      </div>
    </Section>
  );
};

export default About;
